import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
export var capitalizeFirstLetter = function capitalizeFirstLetter(text) {
  var _text$charAt;
  return (text === null || text === void 0 || (_text$charAt = text.charAt(0)) === null || _text$charAt === void 0 ? void 0 : _text$charAt.toUpperCase()) + (text === null || text === void 0 ? void 0 : _sliceInstanceProperty(text).call(text, 1));
};
export var colorVariablesFormat = function colorVariablesFormat(primaryColor, secondaryColor) {
  return {
    "--primary-color": primaryColor,
    "--secondary-color": secondaryColor
  };
};